import type { ReactNode } from 'react';
import { Box, Typography } from './mui-system';

export function EmptyState({
  icon,
  title,
  description,
  action,
}: {
  icon: ReactNode;
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <Box
      sx={{
        py: 6,
        px: 2.5,
        textAlign: 'center',
        border: '1px dashed',
        borderColor: 'divider',
        borderRadius: 2.5,
      }}
    >
      <Box sx={{ fontSize: 38, color: 'text.secondary', mb: 0.7 }}>{icon}</Box>
      <Typography variant="h3" mb={1}>
        {title}
      </Typography>
      <Typography color="text.secondary" maxWidth={480} mx="auto" mb={action ? 2 : 0}>
        {description}
      </Typography>
      {action}
    </Box>
  );
}
